export default "__VITE_ASSET__BywQu4mL__"